const GET_APPROVAL_HISTORY_LIST = 'GET_APPROVAL_HISTORY_LIST'
const SET_APPROVAL_HISTORY_LIST = 'SET_APPROVAL_HISTORY_LIST'

export {
    GET_APPROVAL_HISTORY_LIST,
    SET_APPROVAL_HISTORY_LIST
};